import { render, staticRenderFns } from "./ProjectSearchResultRow.vue?vue&type=template&id=735468a9"
import script from "./ProjectSearchResultRow.vue?vue&type=script&lang=js"
export * from "./ProjectSearchResultRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports